module.exports = __webpack_public_path__ + "static/mark-photo-a4d80916df1c5b56303db70d77b4e4f4.jpg";